import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

/*----------- duplicita s employees/employeetrainings ------------*/

export class TrainingsApiService {

  constructor(private http: HttpClient) { }
    /*** TrainingList*/
    public getTrainingList(searchText = ''): Observable<any> {
        return this.http.get('/api/training-list', {params: {filter: searchText}});
    }

    public postTraining(data): Observable<any> {
        return this.http.post('/api/training-list', data);
    }

    public getTraining(id): Observable<any> {
        return this.http.get('/api/training-list/' + id);
    }

    public putTraining(id, data): Observable<any> {
        return this.http.put('/api/training-list/' + id, data);
    }

    public deleteTraining(id): Observable<any> {
        return this.http.delete('/api/training-list/' + id);
    }

    public postTrainingEmployee(data): Observable<any> {
        return this.http.post('/api/training-list/add-employee', data);
    }

    public getTrainingListBase(): Observable<any>{
        return this.http.get('/api/training-list/list/base');
    }

    public getTrainingListByType(id): Observable<any>{
        return this.http.get('/api/training-list/list/by-type', {params: {idType: id}});
    }

    public getTrainingListEmployees(id): Observable<any>{
        return this.http.get('/api/training-list/' + id + '/employee-list');
    }

    public putTrainingListEmployeeIdTrainingList(idTrainingList, idEmployee, data): Observable<any>{
        return this.http.put('/api/training-list/training-list-employee/' + idTrainingList + '/' + idEmployee, data);
    }

    public deleteTrainingListEmployeeIdTrainingList(idTrainingList, idEmployee): Observable<any>{
        return this.http.delete('/api/training-list/training-list-employee/' + idTrainingList + '/' + idEmployee, {});
    }

    public postTrainingAttachment(id, file): Observable<any>{
        const formData = new FormData();
        formData.append('file', file, file.name);
        return this.http.post('/api/training-list/' + id + '/upload', formData);
    }

    public downloadTrainingAttachment(id): Observable<any> {
        return this.http.get('/api/training-list/download/' + id, {
            responseType: 'blob' as 'json',
            observe: 'response',
        });
    }

    /*** TrainingType*/
    public getTrainingTypes(): Observable<any> {
        return this.http.get('/api/training-type');
    }

    public postTrainingType(data): Observable<any> {
        return this.http.post('/api/training-type', data);
    }

    public putTrainingType(data): Observable<any> {
        return this.http.put('/api/training-type/' + data.id, data);
    }

    public deleteTrainingType(data): Observable<any> {
        return this.http.delete('/api/training-type/' + data.id);
    }

    /*** TrainingTypeEmployee*/
    public postTrainingTypeEmployee(data): Observable<any> {
        return this.http.post('/api/training-type-employee', data);
    }

    public putTrainingTypeEmployee(id, data): Observable<any> {
        return this.http.put('/api/training-type-employee/' + id, data);
    }

    public deleteTrainingTypeEmployee(id): Observable<any> {
        return this.http.delete('/api/training-type-employee/' + id);
    }
}

